module.exports = __webpack_public_path__ + "img/settings.99b3bdb1.svg";